// installRouteNavigationLock 在路径提交后锁定后续跳转，直到页面完成渲染。
export const installRouteNavigationLock = (router, onLockChange) => {
  let locked = false

  router.beforeEach(() => {
    if (locked) {
      return false
    }
  })

  router.afterEach((to, from, failure) => {
    if (failure || to.path === from.path) {
      return
    }
    locked = true
    onLockChange(true)
  })

  // finishRouteNavigation 在 Nuxt 页面完成异步渲染后解除跳转锁。
  return function finishRouteNavigation() {
    if (!locked) {
      return
    }
    locked = false
    onLockChange(false)
  }
}
